import { Show, type Component } from "solid-js";
import { PanelLayout } from "@/shared/panel-base";
import { PanelPreview } from "@/shared/panel-primitives";
import { usePanel } from "@/shared/use-panel";
import { useWs } from "@/shared/ws";
import { registerPanel } from "@/panel-registry";

const HotfixPanel: Component = () => {
  const ws = useWs();
  const enabled = () => ws.state.agentFeatures?.hotfix === true;
  const panel = usePanel(() => ({ isFetching: false, error: null }));

  return (
    <PanelLayout title="Hotfix / KB installées" status={panel.status()}>
      <Show
        when={enabled()}
        fallback={
          <PanelPreview
            feature="hotfix"
            goal="Historique des correctifs et mises à jour appliquées (KB, builds cumulatifs, hotfixes OOB). Complémentaire à WinUpdate qui ne montre que les MAJ en attente."
            tools={[
              {
                name: "hotfix_list",
                description:
                  "Liste des KB installées : HotFixID, Description (Security Update / Update / etc), InstalledOn, InstalledBy",
              },
              { name: "hotfix_search", description: "Recherche par KB number ou description" },
              {
                name: "hotfix_uninstall",
                description:
                  "Désinstaller une KB via wusa /uninstall /kb:NNN (destructif — requiert userConfirmedAt + redémarrage potentiel)",
              },
              {
                name: "hotfix_build_info",
                description:
                  "Build OS + UBR (Update Build Revision) — Get-CimInstance Win32_OperatingSystem + registry SoftwareProtectionPlatform",
              },
              {
                name: "hotfix_pending_reboot",
                description:
                  "Vrai/faux : un redémarrage est en attente suite à une MAJ (registry CBS + Auto Update + WindowsUpdate)",
              },
            ]}
            notes="Backend agent : CIM direct — Win32_QuickFixEngineering dans root/cimv2 (équivalent Get-HotFix mais sans charger le module). Limité aux MSU/MSI. Pour le détail complet (LCU/SSU/cumulative updates) il faut DISM API (DismGetPackages) ou dism.exe /online /Get-Packages — pas d'équivalent CIM. Uninstall via wusa.exe /uninstall /kb:NNN. Pending reboot : combiner registry HKLM\\SOFTWARE\\Microsoft\\Windows\\CurrentVersion\\Component Based Servicing\\RebootPending + WindowsUpdate\\Auto Update\\RebootRequired."
          />
        }
      >
        <div style={{ padding: "12px" }}>Implémentation en cours…</div>
      </Show>
    </PanelLayout>
  );
};

registerPanel("hotfix", HotfixPanel);
export default HotfixPanel;
